"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var Common = require("../../../../utils/CommonUtilFuntions");
var EmptyCartState_1 = require("./EmptyCartState");
var localStyles = require("./EmptyCart.scss");
var ui_components_1 = require("@idp/ui-components");
var RemoveModalContent_1 = require("../../shared/RemoveModalContent");
var Utils = require("../../../../utils/UtilityFunctions");
var utils_1 = require("@idp/ui-components/utils");
var cms_integration_1 = require("@idp/cms-integration");
var Cart_cms_1 = require("../../../../cms/Cart.cms");
var EmptyCart_cms_1 = require("./EmptyCart.cms");
var CartConfiguration_scss_1 = require("../../../CartConfigurationContainer/CartConfiguration.scss");
var ReportingService_1 = require("../../../../api/ReportingService");
var Api_1 = require("../../../../api/Api");
var ModalProps_1 = require("@idp/ui-components/components/atoms/Modal/ModalProps");
var components_1 = require("@idp/duc/components");
var EmptyCart = /** @class */ (function (_super) {
    __extends(EmptyCart, _super);
    function EmptyCart(props) {
        var _this = _super.call(this, props) || this;
        _this.baseURL = '';
        _this.state = new EmptyCartState_1.default();
        _this.bindAll();
        _this.getEmptyCartCMS();
        _this.api = new Api_1.default();
        _this.reportingService = new ReportingService_1.default();
        return _this;
    }
    EmptyCart.prototype.componentDidMount = function () {
        if (window && window.location) {
            this.baseURL = window.location.protocol + "//" + window.location.host;
        }
    };
    EmptyCart.prototype.bindAll = function () {
        this.openEmptyCartModal = this.openEmptyCartModal.bind(this);
        this.closeEmptyCartModal = this.closeEmptyCartModal.bind(this);
        this.getEmptyCartCMS = this.getEmptyCartCMS.bind(this);
    };
    EmptyCart.prototype.render = function () {
        var _this = this;
        return (React.createElement("span", { className: localStyles.linkWithIcon },
            React.createElement(components_1.Link, { kind: "textPlain", onClick: this.openEmptyCartModal, className: CartConfiguration_scss_1.cartLinkMedium, testId: utils_1.default('Empty', 'Cart', 'Link') }, this.saveCartCmsData().emptyLinkLabel),
            React.createElement(ui_components_1.Modal, { testId: utils_1.default('Emptycart', 'Modal', 'Empty_Cart_Modal'), options: {
                    center: true,
                    className: { modalContentClass: CartConfiguration_scss_1.rennyModalCloseBtn },
                    show: this.state.showEmptyCartModal,
                    showClose: true,
                    size: ModalProps_1.ModalSizes.MEDIUM,
                }, events: { onClose: this.closeEmptyCartModal.bind('str') } },
                React.createElement(RemoveModalContent_1.default, { testId: utils_1.default('WLS', 'RemoveModalContent', 'ConfirmRemove'), events: {
                        onCancelClick: function () {
                            _this.openEmptyCartModal();
                        },
                        onRemoveClick: function () {
                            _this.onRemoveClick();
                        },
                    }, data: {
                        currentLOB: Utils.getCurrentLOB(),
                        isBundleinCart: Utils.isBundleinCart().isBundleWithoutAccessory,
                        isSonosinCart: Utils.IsSONOSAccessoryInCart(),
                    } }))));
    };
    EmptyCart.prototype.onRemoveClick = function () {
        var _this = this;
        this.setState({ showEmptyCartModal: false });
        this.reportingService.reportSystemEventForSelectedAction(false, '-2', 'removeItemsLinkLabel', ReportingService_1.EventTypesCodes.EMPTY_CART_SUBMIT_EVENT, ReportingService_1.PageUrls.REMOVE_ALL_ITEMS_MODAL, ReportingService_1.EventTypesCodes.FORM_SUBMIT_EVENT, undefined);
        this.api.emptyAnyLOBCart('').then(function () {
            _this.reportingService.reportSystemEventForSelectedAction(false, '0', 'removeItemsLinkLabel', ReportingService_1.EventTypesCodes.EMPTY_CART_SUBMIT_EVENT, ReportingService_1.PageUrls.REMOVE_ALL_ITEMS_MODAL, ReportingService_1.EventTypesCodes.FORM_RESPONSE_EVENT, undefined);
            Utils.onCartRemoveLob(true);
        }).catch(function (err) {
            _this.openEmptyCartModal();
        });
    };
    EmptyCart.prototype.openEmptyCartModal = function () {
        var _this = this;
        this.setState({ showEmptyCartModal: !this.state.showEmptyCartModal }, function () {
            if (_this.state.showEmptyCartModal) {
                _this.reportingService.fireLinkClickWithOutPageLoad('empty cart', ReportingService_1.PageUrls.REMOVE_ALL_ITEMS_MODAL);
                _this.reportingService.firePageLoadEvent(ReportingService_1.PageUrls.REMOVE_ALL_ITEMS_MODAL);
            }
            else {
                _this.reportingService.fireLinkClickWithOutPageLoad('Close', ReportingService_1.PageUrls.REMOVE_ALL_ITEMS_MODAL);
                //  this.reportingService.firePageLoadEvent(PageUrls.CART_PAGE);
            }
        });
    };
    EmptyCart.prototype.saveCartCmsData = function () {
        /**
         * Reading CMS data from local cms.ts file for cart view.
         * This will be changed when we integrate cartcheckout.cmsfeed.json
         * and legal content using AEM 6.1
         */
        if (!Common.isEmptyObject(this.cartSummaryCMSData)) {
            return this.cartSummaryCMSData;
        }
        this.cartSummaryCMSData = cms_integration_1.CMS.get(new Cart_cms_1.CartCms(), 'cartcheckout').content.common
            .saveRetrieveCart;
        return this.cartSummaryCMSData;
    };
    EmptyCart.prototype.closeEmptyCartModal = function () {
        this.setState({ showEmptyCartModal: false });
        this.reportingService.fireLinkClickWithOutPageLoad('close', ReportingService_1.PageUrls.CART_PAGE);
    };
    EmptyCart.prototype.getEmptyCartCMS = function () {
        var shareCartCMS = cms_integration_1.CMS.get(new Cart_cms_1.CartCms(), 'cartcheckout');
        if (shareCartCMS && shareCartCMS.content &&
            shareCartCMS.content.shareCart) {
            this.emptyCartCMS = shareCartCMS.content.shareCart;
        }
        else {
            this.emptyCartCMS = new EmptyCart_cms_1.EmptyCartCms();
        }
    };
    return EmptyCart;
}(React.Component));
exports.default = EmptyCart;
//# sourceMappingURL=EmptyCart.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/@idse/cart-ui/components/CartLob/shared/EmptyCart/EmptyCart.js
// module id = 2340
// module chunks = 8